import React from 'react';
import PageBanner from "@/components/pageBanner";

const SupportAi = () => {
    return (
        <>
            <PageBanner title="AI Assistant Guides" slug="support-ai"/>
            <section className="generic-container py-14">

                <ul className={"list-disc pl-5"}>
                    <li>
                        <p className="font-bold">How to Create an Account on the Platform</p>
                        <p>
                            Creating an account is quick and easy! Simply enter your email and set a password during registration. Once you've completed the sign-up process, confirm your account by clicking the verification link sent to your email.
                        </p>
                    </li>
                    <li className="mt-4">
                        <p className="font-bold">Gaining Access to the AI Assistant</p>
                        <p>
                            Interested in using the AI Assistant? You’ll need to purchase access to unlock its full capabilities. In this video, we’ll guide you through the process, ensuring you can start using the AI-powered investment tools without any hassle.
                        </p>
                    </li>
                </ul>

            </section>
        </>
    )
}

export default SupportAi;